import type { Ref } from 'vue';

import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { IDownloadListReportPayload } from '@modules/download-report/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import {
  ADMIN_PAYMENT_SYSTEM_DETAILS_LIST_DOWNLOAD_API_URL,
  ADMIN_PAYMENT_SYSTEM_DETAILS_LIST_DOWNLOAD_MUTATION_KEY,
  PAYMENT_SYSTEM_DETAILS_PERMISSIONS,
} from '../constants';
import { EPaymentSystemsTableListType } from '../types';

export default function useDownloadPaymentSystemListMutation(
  tableType: Ref<EPaymentSystemsTableListType>,
): IContextMutationResult<void, Error, IDownloadListReportPayload> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IDownloadListReportPayload>({
    mutationKey: [ADMIN_PAYMENT_SYSTEM_DETAILS_LIST_DOWNLOAD_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      ADMIN_PAYMENT_SYSTEM_DETAILS_LIST_DOWNLOAD_API_URL,
      payload,
      {
        permission: tableType.value === EPaymentSystemsTableListType.PENDING_LIST
          ? PAYMENT_SYSTEM_DETAILS_PERMISSIONS.PENDING_DOWNLOAD_LIST
          : PAYMENT_SYSTEM_DETAILS_PERMISSIONS.HISTORY_DOWNLOAD_LIST,
        urlParams: {
          tableType: tableType.value,
        },
      },
    ),
  });
}
